import { render, staticRenderFns } from "./accountManageList.vue?vue&type=template&id=5e2f1f72&scoped=true"
import script from "./accountManageList.vue?vue&type=script&lang=js"
export * from "./accountManageList.vue?vue&type=script&lang=js"
import style0 from "./accountManageList.vue?vue&type=style&index=0&id=5e2f1f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2f1f72",
  null
  
)

export default component.exports